import React from 'react';
export function Header() {
  return <header className="w-full bg-teal-50 border-b border-teal-100" data-id="element-139">
      <div className="max-w-5xl mx-auto px-4 py-3 flex justify-between items-center" data-id="element-140">
        <div className="flex items-center" data-id="element-141">
          <span className="text-teal-700 font-semibold text-xl" data-id="element-142">TianSole</span>
        </div>
        
      </div>
    </header>;
}